/**
 * What the HUD lays over the game, where an arrow drawn in the world would be
 * hidden: the corners' buttons, the minimap, the spell bar, the chat, the
 * trackers and the frames. Windows are left out: they come and go, and the
 * arrow can wait behind one.
 */
const HUD_SELECTOR = [
  '.hud',
  '.minimap',
  '.spell-bar',
  '.chat',
  '.quest-tracker',
  '.world-event',
  '.party',
  '.alliance',
  '.target-frame',
  '.boss-bar',
  '.touch-actions',
  '.ping-meter',
].join(',');
/** Read the page at most this often: a layout read every frame costs for little. */
const REFRESH_MS = 250;

let cached: { at: number; rects: DOMRect[] } | undefined;

/** The HUD's visible rectangles, in page (CSS) pixels. */
export function hudRects(now: number): readonly DOMRect[] {
  if (cached !== undefined && now - cached.at < REFRESH_MS) return cached.rects;
  const rects = [...document.querySelectorAll<HTMLElement>(HUD_SELECTOR)]
    .filter((element) => !element.hidden && element.getClientRects().length > 0)
    .map((element) => element.getBoundingClientRect())
    .filter((rect) => rect.width > 0 && rect.height > 0);
  cached = { at: now, rects };
  return rects;
}
